'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const utils_mergeClassNames = require('../utils/mergeClassNames.cjs.js');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const listBoxItem = "_list-box-item_afc2v_1";
const styles = {
	listBoxItem: listBoxItem
};

const TypeaheadItem = (_a) => {
  var { children, className, id, size = "large", textValue } = _a, props = tslib_es6.__rest(_a, ["children", "className", "id", "size", "textValue"]);
  const childrenIsPureText = React__default.default.useMemo(() => React__default.default.Children.toArray(children).every((child) => typeof child === "string" || typeof child === "number"), [children]);
  if (!childrenIsPureText && !textValue) {
    console.error("Typeahead.Item: The `textValue` prop must be set if `children` is not plain text.");
  }
  return jsxRuntime.jsx(reactAriaComponents.ListBoxItem, Object.assign({ className: (renderProps) => utils_mergeClassNames.mergeClassNames([styles.listBoxItem, className], renderProps), "data-size": size, "data-zds": true, id, textValue }, props, { children }));
};

exports.TypeaheadItem = TypeaheadItem;
//# sourceMappingURL=TypeaheadItem.cjs.js.map
